"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* example */
var Person = /** @class */function () {
  function Person() {}
  Person.nameless = function (values) {};
  return Person;
}();
// SomeClass.nameless({ name: 'John' }); -> error "Implement all required members"
Person.nameless({
  id: 1
}); // -> name is not required now
Person.nameless({
  id: 1,
  name: 'John'
});
Person.nameless({
  id: 1,
  name: 'John',
  age: 20
});
